csui.define('bundles/nuc-loader',[
  // RequireJS module support; prefer the plugin abbreviations here
  'nuc/lib/require', 'css', 'csui-ext', 'hbs', 'i18n', 'json', 'less',
  'txt', 'nuc/lib/require.config', 'nuc/lib/domReady',
  // Dependencies of nuc/lib/hbs
  'nuc/lib/handlebars', 'nuc/lib/underscore', 'nuc/lib/i18nprecompile',
  'nuc/lib/underscore.deepExtend', 'nuc/lib/underscore.string',
  // Default configuration for the loader modules
  'nuc/config'
], {});
